import { Component, EventEmitter, OnInit, Output, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { Employee, isMeritLevelNeutralOrgCode } from '@coin/shared/core/util-models';
import { MeritBudgetAllocationTotalState } from '../../../../merit/merit-budget-allocation/store/merit-budget-allocation-total.state';
import { MeritBudgetAllocationState } from '../../../../merit/merit-budget-allocation/store/merit-budget-allocation.state';
import { OrganisationService } from '../../../models/organisation-service.model';

@Component({
  selector: 'customer-org-tree-overview-item',
  templateUrl: './org-tree-overview-item.component.html',
  styleUrls: ['./org-tree-overview-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OrgTreeOverviewItemComponent implements OnInit {
  private meritBudgetAllocationState = inject(MeritBudgetAllocationState);
  private meritBudgetAllocationTotalState = inject(MeritBudgetAllocationTotalState);

  readonly head = input<Employee>(undefined);
  readonly level = input<number>(undefined);
  readonly last = input<boolean>(undefined);
  readonly lastParent = input<boolean>(undefined);
  readonly selectedEmployeeId = input<string>(undefined);
  readonly openEmployeeInView = input<(payload: { node: Employee; fullTree: boolean }) => unknown>(undefined);
  readonly service = input<OrganisationService>(undefined);
  readonly seasonId = input<string>(undefined);
  @Output() clickTreeItem = new EventEmitter<void>();

  private maxVisibleLevel: number;

  get disableNavigation(): boolean {
    return this.maxVisibleLevel && this.level() >= this.maxVisibleLevel;
  }

  get isRoot(): boolean {
    return this.level() === 0;
  }

  get isMaxLevel(): boolean {
    return this.level() === 2;
  }

  get isSelected(): boolean {
    return this.head()?.id === this.selectedEmployeeId();
  }

  ngOnInit(): void {
    this.maxVisibleLevel = this.meritBudgetAllocationState.allocationSettings()?.visibleLevels;
  }

  public onClickItem(): void {
    if (!this.disableNavigation) {
      let isFullTree = true;
      if (this.maxVisibleLevel) {
        const level = isMeritLevelNeutralOrgCode(this.head().orgCode) ? this.level() : this.level() + 1;
        this.meritBudgetAllocationTotalState.setCurrentLevel({ level });
        isFullTree = false;
      }
      this.openEmployeeInView()({ node: this.head(), fullTree: isFullTree });
      this.clickTreeItem.emit();
    }
  }
}
